

$(document).ready(function() {
  // Show only one quanity in cart count when multiple times add in cart.
  getCartCount();

  	$(document).on('click','.product-form__cart-submit',function(){

      setTimeout(function(){
          getCartCount();
      }, 1000);

	});

  $('.product-single__thumbnails-item').on('click', function (event){
    $('.product-single__thumbnails-item').removeClass('active');
    $(this).addClass("active");
  });
  $('.site-header__icon.site-header__menu').on('click', function (event){
    $('body').addClass("mobile-side-bar");
  });

  $('.site-header__menu-outer').on('click', function (event){
  	$('body').removeClass("mobile-side-bar");
  });



    var url  = window.location.href;
    var urlsplit = url.split("=");
    var lastpart = urlsplit[urlsplit. length-1];

    lastpart = parseInt(lastpart);

    $('#variant-image-slider.thumbnails-wrapper ul.product-single__thumbnails-product-template').each(function(){

          var data_id = parseInt($(this).attr('data-id'));

          if(lastpart == data_id){
              $('#variant-image-slider.thumbnails-wrapper ul.product-single__thumbnails-product-template').addClass('hide');
              $(this).removeClass('hide');

            $(this).find('li:first').addClass('active');

            var variant_img = $(this).find('li:first a.variant-slider-img img.product-single__thumbnail-image').attr('src');
              $('.metafield-preview_img').val(variant_img);
              if(variant_img){
                  variant_img = variant_img.split('/');
                  variant_img = variant_img[variant_img.length-1];
                  changeImage(variant_img);
              }

          }

    });


  //Mega menu hover JS


  $('#AccessibleNav li.site-nav--has-dropdown').hover(function(){
  	$('#AccessibleNav li.site-nav--has-dropdown').removeClass('site-nav--active-dropdown');
  });


  // PDP JS
  $('.single-option-selector.single-option-selector-product-template').on("change", function(){
    $('button.product-form__cart-submit').removeAttr('disabled');
    // console.log("chnage");
      setTimeout(function(){
        var url  = window.location.href;
        var urlsplit = url.split("=");
        var lastpart = urlsplit[urlsplit. length-1];

        lastpart = parseInt(lastpart);
        $('#product_variant_id').val(lastpart);

        // only 1 times product add in cart not more times
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cart) {
              if(cart.item_count > 0){
                $.each(cart.items, function(idx, item) {
                    // console.log(item.id);
                  var id = parseInt($('#product_variant_id').val());
                  if(id === item.id){
                  }
                });
              }
          },
    	});


        // console.log(lastpart);
        $('.product-form__variants#ProductSelect-product-template option').each(function(){

          var variant_id= parseInt($(this).val());
          if(variant_id == lastpart){
              $(this).attr('selected', 'selected');
              $('#variant_sku').text($(this).attr('data-sku'));
          }

        });
     // poupu js
        $('.product-popup-main').each(function(){
          var data_id = parseInt($(this).attr('data-id'));

          if(lastpart == data_id){
              $('.product-popup-main').removeClass('product-modal');
             $('.product-popup-main').addClass('product-modal-hide');
            $(this).removeClass('product-modal-hide');
          	  $(this).addClass('product-modal');

          }

        });
         $('.popup-slide').each(function(){
            var data_id = parseInt($(this).attr('data-id'));
           var count =  parseInt($(this).attr('count'));

          if(lastpart == data_id){

            $(this).addClass('slides');

            if(count == 1)
            {
              $(this).css({"display": "block"});
            }else{
               $(this).css({"display": "none"});
            }

          }
           else
           {
              $(this).removeClass('slides');
             $(this).css({"display": "none"});
           }



             });

        //product variant image slider
        $('#variant-image-slider.thumbnails-wrapper ul.product-single__thumbnails-product-template').each(function(){

          var data_id = parseInt($(this).attr('data-id'));

          if(lastpart == data_id){
              $('#variant-image-slider.thumbnails-wrapper ul.product-single__thumbnails-product-template').addClass('hide');
              $(this).removeClass('hide');
              $('.product-single__thumbnails-item').removeClass('active');
              $(this).find('li:first').addClass('active');


              var variant_img = $(this).find('li:first a.variant-slider-img img.product-single__thumbnail-image').attr('src');
              $('.metafield-preview_img').val(variant_img);
              if(variant_img){
                  variant_img = variant_img.split('/');
                  variant_img = variant_img[variant_img.length-1];
                  changeImage(variant_img);
              }

              // select dimentional image for pdfmonkey
              $(this).find('li.product-single__thumbnails-item img.product-single__thumbnail-image').each(function(){

              	var image_src = $(this).attr('src');
                var _src = '';
                _src = image_src.split('/');
                _src = _src[_src.length-1];
                _src = _src.split('_');
                _src = _src[0];
                _src = _src.split('-');
                _src = _src[_src.length-1];
                var is_dimentional = _src.includes("D");
                var count = 0;
                if(is_dimentional){
                	count = count +1;
                  if(count == 1){
                  	$('.metafield-image1').val(image_src);
                  }else{
                  	$('.metafield-image2').val(image_src);
                  }

                }

              });

          }

        });

        //Download CAD Block
        $('.download-block .cad-block').each(function(){

        	var data_id = parseInt($(this).attr('data-id'));

          if(lastpart == data_id){
            $('.download-block .cad-block').addClass('hide');
          	$(this).removeClass('hide');
          }

        });

        // Features & Benefits
		$('.features-and-benefits').each(function(){

        	var data_id = parseInt($(this).attr('data-id'));

          if(lastpart == data_id){
            $('.features-and-benefits').addClass('hide');
          	$(this).removeClass('hide');


          }

        });

        // Product Specification
		$('.product-listing-section ul.product-list.product-specification').each(function(){

        	var data_id = parseInt($(this).attr('data-id'));

          if(lastpart == data_id){
            // console.log(data_id);
            $('.product-listing-section ul.product-list.product-specification').addClass('hide');
          	$(this).removeClass('hide');

          }

        });

        // Product Description
		$('#ProductSection-product-template .product-description').each(function(){

        	var data_id = parseInt($(this).attr('data-id'));

          if(lastpart == data_id){
            // console.log(data_id);
            $('#ProductSection-product-template .product-description').addClass('hide');
          	$(this).removeClass('hide');
          }

        });


        // Cart Properties for PDFMonkey
		$('.cart_properties').each(function(){

        	var data_id = parseInt($(this).attr('data-id'));

          if(lastpart == data_id){
            $('.cart_properties').addClass('hide');
          	//$(this).removeClass('hide');
            $(this).children('input').each(function(){

            	var _class = $(this).attr('class');

              	$('input.metafield-'+_class).val($(this).val());

            });


          }

        });

      }, 100);

  });

  $('#variant-image-slider.thumbnails-wrapper ul.product-single__thumbnails-product-template a.variant-slider-img').on("click", function(){

        var variant_image = $(this).children('img.product-single__thumbnail-image').attr('src');

        variant_image = variant_image.split('/');
        variant_image = variant_image[variant_image.length-1];
    // console.log("variant image " + variant_image);
        changeImage(variant_image);

  });


});
function changeImage(variant_img){

  $('.product-single .product-single__media-group .product-main-image.product-single__media-wrapper').each(function(){

    var product_image = $(this).children('.product-main-single-media.product-single__media').attr('data-src');
    product_image = product_image.split('/');
    product_image = product_image[product_image.length-1];
    product_image = product_image.split('_');
    product_image = product_image[0];

    var flag = variant_img.includes(product_image);
    if(flag){
      // console.log("product image " + product_image);
      $('.product-single .product-single__media-group .product-main-image.product-single__media-wrapper').addClass('hide');
      $(this).removeClass('hide');

    }

  });
}
function getCartCount(){
	$.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {

            // console.log("onUpdate"+cart.item_count);
          var count = 0
          $.each(cart.items, function(idx, item) { count = count+1;});
          // console.log(count);
            $('.mylist.cart-count span[data-cart-count]').text("My specification("+count+")");
          	$('.mylist .cart-count .site-header__cart-count span[data-cart-count]').text("My spec("+count+")");
          	$('.cart-popup a.cart-popup__cta-link span[data-cart-popup-cart-quantity]').text(count);
          	$('.cart-popup a.cart-popup__cta-link span[data-cart-popup-cart-quantity]').attr('aria-label', count+' items');
        },
    });
}
